
// h5端
import Fly from 'flyio/dist/npm/fly'











import store from '../store'
import {
	handleLoginFailure
} from '@/utils'
import {
	VUE_APP_API_URL
} from '@/config'
import cookie from '@/utils/store/cookie'

const fly = new Fly()
fly.config.baseURL = VUE_APP_API_URL

// 小程序测试请求域名









fly.interceptors.response.use(
	response => {
		return response
	},
	error => {

		if (error.toString() == 'Error: Network Error') {
			handleLoginFailure()
			return Promise.reject({
				msg: '未登录',
				toLogin: true
			})
		}
		if (error.status == 401) {
			handleLoginFailure()
			return Promise.reject({
				msg: '未登录',
				toLogin: true
			})
		}
		if (error.response.data.status == 5109) {
			uni.showToast({
				title: error.response.data.msg,
				icon: 'none',
				duration: 2000,
			})
		}
		return Promise.reject(error)
	}
)

const defaultOpt = {
	login: true
}

function baseRequest(options) {

	const token = cookie.get('login_status')

	options.headers = {
		...options.headers,
	}
	if (options.login === true) {
		options.headers = {
			...options.headers,
			Authorization: 'Bearer ' + token,
		}
	}

	// 结构请求需要的参数
	const {
		url,
		params,
		data,
		login,
		...option
	} = options

	// 发起请求
	return fly.request(url, params || data, {
		...option,
	}).then(res => {
		const data = res.data || {}
		if (res.status !== 200) {
			return Promise.reject({
				msg: '请求失败',
				res,
				data
			})
		}
		
		if (data.code == 401 || data.code == 403) {
			handleLoginFailure()
			return Promise.reject({
				msg: res.data.msg,
				res,
				data,
				toLogin: true
			})
		} else if (data.status === 200) {
			return Promise.resolve(data, res)
		} else if (data.status == 5101) {
			return Promise.reject({
				msg: res.data.msg,
				res,
				data
			})
		} else {
			return Promise.reject({
				msg: res.data.msg,
				res,
				data
			})
		}
	})
}

/**
 * http 请求基础类
 * 参考文档 https://www.kancloud.cn/yunye/axios/234845
 *
 */
const request = ['post', 'put', 'patch'].reduce((request, method) => {
	/** 
	 * @param url string 接口地址
	 * @param data object get参数
	 * @param options object axios 配置项
	 * @returns {AxiosPromise}
	 */
	request[method] = (url, data = {}, options = {}) => {
		return baseRequest(Object.assign({
			url,
			data,
			method
		}, defaultOpt, options))
	}
	return request
}, {});

['get', 'delete', 'head'].forEach(method => {
	/** 
	 * @param url string 接口地址
	 * @param params object get参数
	 * @param options object axios 配置项
	 * @returns {AxiosPromise}
	 */
	request[method] = (url, params = {}, options = {}) => {
		return baseRequest(Object.assign({
			url,
			params,
			method
		}, defaultOpt, options))
	}
})

export default request
